export const HTTP_SUCCESS_STATUSES = [200, 201];
export const HTTP_UNAUTHORIZED_STATUS = 401;